export default __webpack_public_path__ + "static/brandon-black-f5e6232102df5d003264e50121d9a832.woff2";